<h2>&nbsp;</h2>

<p>
  <a class="btn btn-outline-primary" [routerLink]="['listak']"><i class="fa fa-list"></i> Email listák kezelése</a>
</p>

<p>
  <a class="btn btn-outline-primary" [routerLink]="['kuldes']"><i class="fa fa-paper-plane-o"></i> Email küldés</a>
</p>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-options/email-options.component.html